var React = require('react');

function SearchIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#202020","fillRule":"evenodd","d":"M14.739 13.521L10.218 9c.695-.912 1.086-2.086 1.086-3.347A5.64 5.64 0 005.653 0 5.642 5.642 0 000 5.652a5.64 5.64 0 005.652 5.652A5.609 5.609 0 009 10.217l4.522 4.522a.86.86 0 00.609.261.86.86 0 00.609-.26.841.841 0 00-.001-1.219zM5.653 9.565A3.896 3.896 0 011.74 5.652 3.896 3.896 0 015.653 1.74a3.896 3.896 0 013.913 3.912 3.897 3.897 0 01-3.913 3.913z","opacity":".4"}));
}

SearchIconInline.defaultProps = {"width":"15","height":"15"};

module.exports = SearchIconInline;

SearchIconInline.default = SearchIconInline;
